export const extras = {
  fr: {
    badge: {
      title: "Traductions certifiées conformes",
      text: "Acceptées par toutes les administrations françaises et étrangères.",
    },
    adminExport: "Exporter CSV",
    serviceNotes: {
      shippingTitle: "Expédition des documents",
      shippingPoints: [
        "L'expédition des documents se fait par lettre verte suivie par défaut. Les coûts d'affranchissement sont en sus du prix des traductions.",
        "Pour une expédition en lettre recommandée avec ou sans accusé de réception, Chronopost, FedEx, etc., le prix de l'expédition sera indiqué dans le devis suite à votre demande spécifique.",
        "Dans le cas d'un envoi non suivi, il n'est pas possible de garantir la livraison.",
        "En cas de retour du courrier pour non-réception, les documents seront réexpédiés par lettre recommandée avec accusé de réception, à la charge du destinataire.",
      ],
      paymentTitle: "Paiement",
      paymentPoints: [
        "Auto-entrepreneur, je ne suis pas soumise à la TVA pour l'heure. TVA non applicable, art. 293 B du CGI.",
        "Tout travail de traduction / interprétariat ne commencera qu'une fois le devis accepté et le paiement intégralement reçu. Paiement par chèque, espèces ou virement. Autre moyen : me contacter.",
      ],
    },
  },
  en: {
    badge: {
      title: "Compliant certified translations",
      text: "Accepted by all French and foreign authorities.",
    },
    adminExport: "Export CSV",
    serviceNotes: {
      shippingTitle: "Document shipping",
      shippingPoints: [
        "Documents are shipped by tracked standard letter (lettre verte suivie) by default. Postage costs are charged in addition to the price of translations.",
        "For shipping by registered letter with or without acknowledgement of receipt, Chronopost, FedEx, etc., the shipping price will be shown in the quote following your specific request.",
        "For untracked shipping, delivery cannot be guaranteed.",
        "If mail is returned for non-delivery, documents will be resent by registered letter with acknowledgement of receipt, at the recipient's expense.",
      ],
      paymentTitle: "Payment",
      paymentPoints: [
        "As a sole trader (auto-entrepreneur), I am currently not subject to VAT. VAT not applicable, art. 293 B of the French General Tax Code.",
        "Any translation or interpreting work will only begin once the quote has been accepted and payment received in full. Payment by cheque, cash or bank transfer. Other methods: please contact me.",
      ],
    },
  },
  ru: {
    badge: {
      title: "Заверенные переводы по всем требованиям",
      text: "Принимаются всеми французскими и зарубежными администрациями.",
    },
    adminExport: "Экспорт CSV",
    serviceNotes: {
      shippingTitle: "Отправка документов",
      shippingPoints: [
        "По умолчанию документы отправляются отслеживаемым простым письмом (lettre verte suivie). Почтовые расходы оплачиваются дополнительно к стоимости перевода.",
        "При отправке заказным письмом с уведомлением о вручении или без, Chronopost, FedEx и т. д. стоимость отправки будет указана в расчёте по вашему запросу.",
        "При отправке без отслеживания гарантировать доставку невозможно.",
        "Если письмо возвращается из-за неполучения, документы отправляются повторно заказным письмом с уведомлением о вручении за счёт получателя.",
      ],
      paymentTitle: "Оплата",
      paymentPoints: [
        "Как индивидуальный предприниматель (auto-entrepreneur), я в настоящее время не облагаюсь НДС. НДС не применяется, ст. 293 B Общего налогового кодекса Франции.",
        "Любая работа по переводу начинается только после принятия расчёта и полной оплаты. Оплата чеком, наличными или банковским переводом. Другие способы — свяжитесь со мной.",
      ],
    },
  },
  ua: {
    badge: {
      title: "Засвідчені переклади за всіма вимогами",
      text: "Приймаються всіма французькими та закордонними адміністраціями.",
    },
    adminExport: "Експорт CSV",
    serviceNotes: {
      shippingTitle: "Надсилання документів",
      shippingPoints: [
        "Типово документи надсилаються простим листом із відстеженням (lettre verte suivie). Поштові витрати сплачуються додатково до вартості перекладу.",
        "При надсиланні рекомендованим листом з повідомленням про вручення або без, Chronopost, FedEx тощо вартість буде вказана в розрахунку за вашим запитом.",
        "При надсиланні без відстеження гарантувати доставку неможливо.",
        "Якщо лист повертається через неотримання, документи надсилаються повторно рекомендованим листом з повідомленням про вручення за рахунок отримувача.",
      ],
      paymentTitle: "Оплата",
      paymentPoints: [
        "Як фізична особа-підприємець (auto-entrepreneur), я наразі не є платником ПДВ. ПДВ не застосовується, ст. 293 B Загального податкового кодексу Франції.",
        "Будь-яка робота з перекладу розпочинається лише після прийняття розрахунку та повної оплати. Оплата чеком, готівкою або банківським переказом. Інші способи — зв'яжіться зі мною.",
      ],
    },
  },
};
